import React from 'react';

const Warranty = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl font-bold mb-8 text-center">Warranty Policy</h1>
      
      <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
        <h2 className="text-2xl font-bold mb-4">Warranty Coverage</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="border rounded-lg p-4 text-center">
            <div className="text-3xl font-bold text-red-600">3 Years</div>
            <p className="text-gray-600">Vehicle Warranty</p>
          </div>
          <div className="border rounded-lg p-4 text-center">
            <div className="text-3xl font-bold text-red-600">50,000 km</div>
            <p className="text-gray-600">Mileage Limit</p>
          </div>
          <div className="border rounded-lg p-4 text-center">
            <div className="text-3xl font-bold text-red-600">5 Years</div>
            <p className="text-gray-600">Battery Warranty</p>
          </div>
        </div>
        
        <h3 className="text-xl font-bold mb-3">What's Covered</h3>
        <ul className="list-disc list-inside space-y-2 mb-6 text-gray-700">
          <li>Manufacturing defects in materials and workmanship</li>
          <li>Battery performance degradation below 70% capacity</li>
          <li>Electric motor and controller defects</li>
          <li>Charging system components</li>
          <li>Frame and structural integrity</li>
        </ul>
        
        <h3 className="text-xl font-bold mb-3">What's Not Covered</h3>
        <ul className="list-disc list-inside space-y-2 mb-6 text-gray-700">
          <li>Normal wear and tear items (tires, brake pads, etc.)</li>
          <li>Damage due to accidents or misuse</li>
          <li>Unauthorized modifications or repairs</li>
          <li>Improper maintenance or charging practices</li>
          <li>Damage from natural disasters or external factors</li>
        </ul>
        
        <h3 className="text-xl font-bold mb-3">How to Claim Warranty</h3>
        <ol className="list-decimal list-inside space-y-2 text-gray-700">
          <li>Contact your nearest Janvahan service center</li>
          <li>Provide proof of purchase and vehicle documents</li>
          <li>Describe the issue in detail</li>
          <li>Schedule an inspection appointment</li>
          <li>Authorized technician will assess and process the claim</li>
        </ol>
      </div>
      
      <div className="bg-gray-100 rounded-lg p-6">
        <h3 className="text-xl font-bold mb-2">Need Assistance?</h3>
        <p className="text-gray-700 mb-4">Our customer support team is here to help you with warranty-related queries.</p>
        <div className="flex space-x-4">
          <a href="/support" className="text-red-600 font-semibold hover:underline">Contact Support →</a>
          <a href="/service-centers" className="text-red-600 font-semibold hover:underline">Find Service Center →</a>
        </div>
      </div>
    </div>
  );
};

export default Warranty;